export const isInMaintenance = (response: Response) => {
  return response && response.status === 420;
};

export const maintenanceReload = () => {
  window.location.reload();
};
